import ComprasPorMotivoAdjudicacion from './ComprasPorMotivoAdjudicacion';

export default ComprasPorMotivoAdjudicacion;
